import { AfterViewInit, ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy, OnInit, TemplateRef, ViewChild, signal } from '@angular/core';
import screenfull from 'screenfull';
import { PublicService } from 'src/app/shared/serviceLayer/public-service';
import { BidStockService } from '../auction-join/services/bid-stock.service ';
import { AuctionStockService } from '../auction-join/services/auction-stock.service';
import { ActivatedRoute, Router } from '@angular/router';
import { takeUntil } from 'rxjs/operators';
import { Subject, firstValueFrom } from 'rxjs';
import { SpinnerVisibilityService } from 'ng-http-loader';
import { ConfirmdialogServiceService } from 'src/app/shared/confirmation-dialog/confirmdialog-service.service';
import { SharedService } from 'src/app/shared/serviceLayer/shared.service';
import { ToastrService } from 'ngx-toastr';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { ConnectionService } from '../auction-join/services/connection.service';
import { COUNTRY_CODES } from 'src/assets/country-codes';
import { SocketAuctionJoinService } from '../auction-join/services/socket-auction-join.service';
import { allConstant } from 'src/app/_helpers/const';

@Component({
  standalone: false,
  selector: 'app-youtube-banner',
  templateUrl: './youtube-banner.component.html',
  styleUrls: ['./youtube-banner.component.scss'],
  providers: [SocketAuctionJoinService, ConnectionService],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class YoutubeBannerComponent implements OnInit, AfterViewInit, OnDestroy {

  private destroy$ = new Subject<void>();

  historyData = signal<any[]>([{ isFrontEnd: true }]);
  auctionId: any;
  auctionDetailsData = signal<any>(null);
  currentUser = signal<any>(null);
  showVehicle = signal<any>('');
  isSold = signal(false);
  isUnSold = signal(false);
  isUnderApproval = signal(false);
  isPause = signal(false);
  currentVehicleOnBid = signal<any>(null);
  upcomingInventoryList = signal<any[]>([]);
  showImage = signal(true);
  showReservePrice = signal(true);
  aprovalStatus = signal(true);
  cycleInterval: any;
  laneDetails = signal<any>(null);
  laneId: any;
  BidSettings: any = { isEmitted: false, lastBidCount: 0 };
  isShowReservePriceObj = signal<any>(null);
  isShowMarketPriceObj = signal<any>(null);
  bidTimeCounterUp = signal<any>(null);
  backgroundMusic: any;
  isOnline = signal(true);
  isDisconnected = signal(false);
  isConnected = signal(false);
  connectioinCount = 0;
  beepFlag = signal(false);
  netSpeedMbps = signal<number | null>(null);
  netType = signal<string>('unknown');
  netRttMs = signal<number | null>(null);
  isShowNetWarning = signal(false);
  private browserConnection: any = null;
  private readonly networkChangeHandler = () => this.updateNetworkInfo();

  @ViewChild('templateModal') templateModal: TemplateRef<any>;
  dialogRef: BsModalRef<any>;

  constructor(
    private bidStockService: SocketAuctionJoinService,
    private auctionService: AuctionStockService,
    private publicService: PublicService,
    private router: ActivatedRoute,
    private modalService: BsModalService,
    private toastr: ToastrService,
    public sharedService: SharedService,
    private connectionService: ConnectionService,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit() {
    this.connectionService.startPinging();
    this.setupConnectionListeners();
    this.wakeupfunction();
    this.currentUser.set({ _id: '644bb2165b522f97549c00a6' });
    this.router.queryParams.subscribe(async (params) => {
      this.auctionId = params['id'];
      this.laneId = params['laneId'];
      await this.getAuctionDetail(this.auctionId);
      this.firstTimeFunctionInitialization();
    });
    this.receiveReservePriceStatus();
    this.receiveMarketPriceStatus();
    this.startReservePriceCycle();
    this.initNetworkSpeedMonitoring();
  }

  async firstTimeFunctionInitialization() {
    this.isCarApprovedSubscribe();
    this.lastFiveBidsSubscribe();
    this.onlineBidSubscription();
    await this.getPendingCar();
    this.forceRefreshSubscribe();
    this.bannerRefreshSubscribe();
    this.auctionResumePauseFunSubscribe();
    this.isSoldSubscribe();
    this.isUnSoldSubscribe();
    this.getSkipStatusSubscribe();
    this.isUnderApprovalSubscribe();
    this.isAuctionVehicleReloadSubscription();
    this.RevceiveFunctionalAudioMessageSubscription();
    this.VehicleTimerCounterUPSubscription();
    this.isConnectedSubscription();
    this.isDisconnectSubscription();
  }

  VehicleTimerCounterUPSubscription() {
    this.bidStockService.vehicleTimerSubscription()
      .pipe(takeUntil(this.destroy$))
      .subscribe((res: any) => {
        if (res && Object.keys(res).length != 0 && res.constructor === Object) {
          this.bidTimeCounterUp.set(res);
        }
      });
  }

  receiveReservePriceStatus() {
    this.bidStockService.receiveReservePriceStatus()
      .pipe(takeUntil(this.destroy$))
      .subscribe((res: any) => {
        if (res && Object.keys(res).length !== 0 && res.constructor === Object) {
          this.isShowReservePriceObj.set(res);
        }
      });
  }

  receiveMarketPriceStatus() {
    this.bidStockService.receiveMarketPriceStatus()
      .pipe(takeUntil(this.destroy$))
      .subscribe((res: any) => {
        if (res && Object.keys(res).length != 0 && res.constructor === Object) {
          this.isShowMarketPriceObj.set(res);
        }
      });
  }

  speakText(text): void {
    this.sharedService.speak(text);
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
    this.bidStockService.unsubscribeReceiveFunctionalAudioMessage();
    this.bidStockService.socketend(this.auctionId, this.currentUser()?._id, this.laneDetails()?._id);
    if (this.cycleInterval) { clearInterval(this.cycleInterval); }
    this.connectionService.stopPinging();
    this.cleanupNetworkSpeedMonitoring();
  }

  startReservePriceCycle() {
    this.cycleInterval = setInterval(() => {
      this.showReservePrice.set(!this.showReservePrice());
    }, 3000);
  }

  ngAfterViewInit() {
    this.isPause.set(this.auctionDetailsData()?.isAuctionPaused);
  }

  toggleFullScreen() {
    if (screenfull.isEnabled) { screenfull.toggle(); }
  }

  async getAuctionDetail(id: any) {
    const data: any = await this.publicService.getAuctionDetail({ auctionId: id }).toPromise();
    if (data.data) {
      this.auctionDetailsData.set(data.data);
      debugger
      this.laneDetails.set(
        this.auctionDetailsData().lanes?.find((lane: any) => lane._id === this.laneId)
      );
      console.log("laneDetails", this.laneDetails());
      debugger
      this.isPause.set(this.laneDetails()?.pause);
    }
  }

  isSoldSubscribe() {
    this.bidStockService.isSoldSubscription()
      .subscribe((res: any) => {
        if (res && Object.keys(res).length != 0 && res.constructor === Object) {
          if (res.status == true) {
            this.isSold.set(res.status);
            setTimeout(() => { this.allReloadFunction(); }, 5000);
          }
        }
      });
  }

  isUnderApprovalSubscribe() {
    this.bidStockService.isUnderApprovalSubscribe()
      .subscribe((res: any) => {
        if (res && Object.keys(res).length != 0 && res.constructor === Object) {
          if (res.status == true) {
            this.isUnderApproval.set(res.status);
            setTimeout(() => { this.allReloadFunction(); }, 5000);
          }
        }
      });
  }

  isUnSoldSubscribe() {
    this.bidStockService.isUnSoldSubscription()
      .subscribe((res: any) => {
        if (res && Object.keys(res).length != 0 && res.constructor === Object) {
          if (res.status == true) {
            this.isUnSold.set(res.status);
            setTimeout(() => { this.allReloadFunction(); }, 5000);
          }
        }
      });
  }

  auctionResumePauseFunSubscribe() {
    this.bidStockService.pauseAuction()
      .subscribe((val: any) => {
        if (val == true) { this.isPause.set(true); }
        else if (val === false) { this.isPause.set(false); }
      });
  }

  lastFiveBidsSubscribe() {
    this.bidStockService.lastFiveBidsSubscription(this.auctionId)
      .subscribe((res: any) => {
        if (res) {
          if (this.historyData()?.length > 0 && this.BidSettings?.lastBidCount > 1) {
            const timediff = -(this.getTimeDiffrence(res[0]?.createdAt));
            if (timediff >= allConstant.bidSetting.bidTimeGap) {
              if (this.BidSettings.lastBidCount > 2 && this.isShowNetWarning() == false) {
                const interval = setInterval(() => {
                  this.updateNetworkInfo();
                  if (!this.isShowNetWarning()) { clearInterval(interval); }
                }, 2000);
              }
              if (this.isShowNetWarning() == false) { this.updateNetworkInfo(); }
            }
          }
          this.BidSettings['lastBidCount'] += 1;
          this.historyData.set(res);
        }
      });
  }

  onlineBidSubscription() {
    this.bidStockService.onlineBidAmountSubscription()
      .subscribe((res: any) => {
        if (res > 0) { this.speakText(`${res} online`); }
      });
  }

  isAuctionVehicleReloadSubscription() {
    this.bidStockService.isAuctionVehicleReloadSubscription()
      .subscribe((res: any) => {
        if (res && Object.keys(res).length != 0 && res.constructor === Object) {
          if (res.status == true) { this.allReloadFunction(); }
        }
      });
  }

  allReloadFunction() {
    this.allResetValues();
    this.isSold.set(false);
    this.isUnSold.set(false);
    this.isUnderApproval.set(false);
    this.getPendingCar();
  }

  isCarApprovedSubscribe() {
    this.bidStockService.isCarApproved()
      .subscribe((val: any) => {
        if (val === true || val === false) {
          if (val === true && this.aprovalStatus() !== true) { this.speakText('Green Light'); }
          this.aprovalStatus.set(val ? true : false);
        }
      });
  }

  getSkipStatusSubscribe() {
    this.bidStockService
      .getSkipStatus(this.auctionId, this.currentVehicleOnBid()?.inventoryId)
      .subscribe((res: any) => {
        if (res && Object.keys(res).length != 0 && res.constructor === Object) {
          if (res.status == true) { setTimeout(() => { this.allReloadFunction(); }, 1000); }
        }
      });
  }

  forceRefreshSubscribe() {
    this.bidStockService.forceRefresh()
      .subscribe((val: any) => {
        if (val?.status == true) {
          if (this.currentVehicleOnBid()?.inventoryId != val?.inventoryId) { this.allReloadFunction(); }
        }
      });
  }

  bannerRefreshSubscribe() {
    this.bidStockService.bannerRefreshSubscribe()
      .subscribe((val: any) => {
        if (val?.status == true) {
          if (this.currentVehicleOnBid()?.inventoryId != val?.inventoryId) { this.allReloadFunction(); }
        }
      });
  }

  emitIsCarApproved() {
    this.bidStockService.emitIsCarApproved(this.auctionId, this.currentVehicleOnBid()?.inventoryId, this.laneDetails()?._id);
  }

  emitLastFiveBids() {
    this.bidStockService.emitLastFiveBides(this.auctionId, this.currentVehicleOnBid()?.inventoryId, this.laneDetails()?._id);
  }

  joinAcution() {
    this.bidStockService.joinAuction(this.auctionId, this.currentVehicleOnBid().inventoryId, this.currentUser()?._id, this.auctionDetailsData()?.auctionStart, this.laneDetails()?._id);
  }

  GetAuctionInformation(auctionId: any): Promise<any> {
    return this.auctionService.auctionVehicleList({
      pageLimit: 3,
      page: 1,
      auctionId: auctionId,
      inventoryStatus: 2,
      userId: this.currentUser()?._id,
      status: 'pending',
    }).toPromise();
  }

  async getPendingCar(): Promise<any> {
    let data = {
      auctionId: this.auctionId,
      userId: this.currentUser()?._id,
      page: 1,
      pageLimit: 4,
      lane: this.laneDetails()?.lane,
    };

    this.showImage.set(false);
    const response: any = await firstValueFrom(this.auctionService.getPendingPublicAuctionVehicle(data));
    this.showImage.set(true);

    if (response?.status) {
      if (response?.data?.length > 1) {
        this.currentVehicleOnBid.set(response.data[0]);
        this.upcomingInventoryList.set(response.data.slice(1));
      } else {
        this.currentVehicleOnBid.set(response.data[0]);
        this.upcomingInventoryList.set([]);
      }

      if (response?.data?.length === 0) {
        window.location.href = '/auctions';
        return;
      }

      this.isShowReservePriceObj.set({ status: this.currentVehicleOnBid()?.showReservePrice, reservePrice: this.currentVehicleOnBid()?.reservePrice });
      this.isShowMarketPriceObj.set({ status: this.currentVehicleOnBid()?.showMarketPrice, marketPrice: this.currentVehicleOnBid()?.marketPrice });

      this.joinAcution();
      this.BidSettings['isEmitted'] = true;
      this.BidSettings['lastBidCount'] = 0;
      this.emitLastFiveBids();
      this.emitIsCarApproved();

      this.currentVehicleOnBid.update(v => ({
        ...v,
        images: v.images.map((img: string) => this.sharedService.cloudFrontUrl('500x400', img)),
      }));
    }
  }

  allResetValues() {
    this.showVehicle.set('');
    this.historyData.set([]);
  }

  wakeupfunction() {
    document.addEventListener('visibilitychange', this.handleVisibilityChange);
  }

  private setupConnectionListeners() {
    this.connectionService.status$.subscribe((isOnline) => {
      if (this.isOnline() == false && isOnline == true) {
        this.isOnline.set(true);
        this.isDisconnected.set(false);
        this.updateNetworkWarningState();
        this.allReloadFunction();
        return;
      }
      if (this.isOnline() == true && isOnline == false) {
        this.isOnline.set(false);
        this.isDisconnected.set(true);
        this.updateNetworkWarningState();
        this.toastr.show('Connection Lost!!!', 'Warning');
      }
    });
  }

  handleVisibilityChange = () => {
    if (!document.hidden) { this.connectionService.startPinging(); }
    if (document.hidden) {
      this.connectionService.stopPinging();
      this.backgroundMusic?.pause();
    } else {
      if (this.isOnline() == true) {
        this.allReloadFunction();
        this.backgroundMusic?.paused ? this.backgroundMusic.play() : '';
      } else {
        this.toastr.show('Connection Lost!!!', 'Warning');
      }
    }
  };

  getTimeDiffrence(endDate: any) {
    const diff = new Date(endDate).getTime() - new Date().getTime();
    return Math.floor((diff / 1000) % 60);
  }

  RevceiveFunctionalAudioMessageSubscription() {
    this.bidStockService.RevceiveFunctionalAudioMessageSubscription()
      .pipe(takeUntil(this.destroy$))
      .subscribe((res: any) => {
        if (res && Object.keys(res).length != 0 && res.constructor === Object) {
          if (res.type) {
            res.type == 'background' ? this.playBackgroundMusic(res) : this.playBeep(res.link, res.duration, res);
          }
        }
      });
  }

  playBeep(message, durationtime, data: any = null) {
    if (data?.type == 'online-bid') { return; }
    let audio = new Audio(message);
    audio.volume = 0.5;
    if (!this.currentUser()?.isAuctionMute) { /* audio.play() */ }
  }

  playMessage(message: any) {
    var audio = new Audio(message);
    if (!this.currentUser()?.isAuctionMute) { /* audio.play() */ }
  }

  async waitForUserClick(): Promise<MouseEvent> {
    return new Promise((resolve) => {
      const listener = (event: MouseEvent) => {
        window.removeEventListener('click', listener);
        resolve(event);
      };
      window.addEventListener('click', listener);
    });
  }

  playBackgroundMusic(data: any) {
    if (data && data?.link && data?.link != '') {
      this.backgroundMusic = new Audio(data?.link);
      this.backgroundMusic.loop = data?.loop;
      this.backgroundMusic.volume = data?.volume;
      if (!this.currentUser()?.isAuctionMute) { /* this.backgroundMusic.play() */ }
    }
  }

  openModal() {
    this.dialogRef = this.modalService.show(this.templateModal);
  }

  getCountryIsoCode(countryCode: string): string {
    return COUNTRY_CODES[countryCode] || '';
  }

  getFlagUrl(countryCode: string): string {
    const iso = this.getCountryIsoCode(countryCode);
    return iso ? `https://flagcdn.com/16x12/${iso}.png` : '';
  }

  isDisconnectSubscription() {
    this.bidStockService.isDisconnectSubscription()
      .subscribe((val: any) => {
        if (val && Object.keys(val).length != 0 && val.constructor === Object) {
          this.toastr.warning('auction disconnected and trying to connect');
          this.isDisconnected.set(true);
          this.isConnected.set(false);
          this.updateNetworkWarningState();
        }
      });
  }

  isConnectedSubscription() {
    this.bidStockService.isConnectedSubscription()
      .subscribe((val: any) => {
        if (val && Object.keys(val).length != 0 && val.constructor === Object) {
          this.toastr.success('auction connected');
          this.isOnline.set(true);
          if (this.isDisconnected() === true && this.connectioinCount > 0) { this.allReloadFunction(); }
          this.isDisconnected.set(false);
          this.isConnected.set(true);
          this.connectioinCount += 1;
          this.updateNetworkWarningState();
        }
      });
  }

  //#region <-------------START NETWORK SPEED SECTION------------->

  private initNetworkSpeedMonitoring() {
    const nav: any = navigator;
    this.browserConnection = nav?.connection || nav?.mozConnection || nav?.webkitConnection;
    this.updateNetworkInfo();
    if (this.browserConnection?.addEventListener) {
      this.browserConnection.addEventListener('change', this.networkChangeHandler);
    }
    window.addEventListener('online', this.networkChangeHandler);
    window.addEventListener('offline', this.networkChangeHandler);
  }

  private cleanupNetworkSpeedMonitoring() {
    if (this.browserConnection?.removeEventListener) {
      this.browserConnection.removeEventListener('change', this.networkChangeHandler);
    }
    window.removeEventListener('online', this.networkChangeHandler);
    window.removeEventListener('offline', this.networkChangeHandler);
  }

  private updateNetworkInfo() {
    const nav: any = navigator;
    const connection = this.browserConnection || nav?.connection || nav?.mozConnection || nav?.webkitConnection;
    if (!navigator.onLine) {
      this.netSpeedMbps.set(0);
      this.netType.set('offline');
      this.netRttMs.set(null);
      this.updateNetworkWarningState();
      return;
    }
    this.netSpeedMbps.set(typeof connection?.downlink === 'number' ? connection.downlink : null);
    this.netType.set(connection?.effectiveType || 'online');
    this.netRttMs.set(typeof connection?.rtt === 'number' ? connection.rtt : null);
    this.updateNetworkWarningState();
  }

  private updateNetworkWarningState() {
    const minSpeed = allConstant.internetSpeadCheck.netSpeedMbps;
    const maxLatency = allConstant.internetSpeadCheck.latency;
    const isSlowSpeed = this.netSpeedMbps() !== null ? this.netSpeedMbps() < minSpeed : false;
    const isHighLatency = this.netRttMs() !== null ? this.netRttMs() > maxLatency : false;
    this.isShowNetWarning.set(isSlowSpeed || isHighLatency);
  }

  get netWarningMessage(): string {
    if (!navigator.onLine || !this.isOnline() || this.isDisconnected()) {
      return 'You are disconnected. Trying to reconnect. Please check your internet connection.';
    }
    if (this.netSpeedMbps() !== null) { return `Network is unstable (${this.netSpeedMbps().toFixed(1)} Mbps).`; }
    return 'Network is unstable. Connection quality is low.';
  }

  get networkSpeedLabel(): string {
    if (!navigator.onLine || this.netType() === 'offline') { return 'OFFLINE'; }
    if (this.netSpeedMbps() !== null) { return `${this.netSpeedMbps().toFixed(1)} Mbps`; }
    return this.netType() ? this.netType().toUpperCase() : 'N/A';
  }

  //#endregion <-------------END NETWORK SPEED SECTION------------->
}
